let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("asSvh")).then(() => parcelRequire('24p1b'));